/* eslint-disable react/destructuring-assignment */

import _ from 'lodash';

const ModalContent = (props) => {
  let content = props.children;

  if (_.isString(props.children)) {
    const markup = { __html: props.children };
    // eslint-disable-next-line react/no-danger
    content = <div dangerouslySetInnerHTML={markup} />;
  }

  return <div className="modal__content">{content}</div>;
};

export default ModalContent;
